import { UserStatus } from "../../constants";

import updateUserModalImg from "../../assets/images/app/allaya/update-icon.svg";

export const MODAL_CONTENT_CONFIG = {
    [UserStatus.INACTIVE]: {
        modalTitle: "Update User",
        modalSubText: "Are you sure you want to Inactivate this user?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: updateUserModalImg
    },
    [UserStatus.ACTIVE || UserStatus.UNVERIFIED]: {
        modalTitle: "Update User",
        modalSubText: "Are you sure you want to activate this user?",
        yesButtonText: "Yes",
        noButtonText: "Cancel",
        imageSrc: updateUserModalImg
    }
};
